import { entryLinks, heroImage, statCards } from "@/mocks/homeData";

export default function HeroBoard() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="黑料照片来源溯源门户背景，抽象剪报与照片碎片拼贴"
          title="黑料照片首发出处溯源归档"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 py-10 md:px-6 md:py-16">
        <div className="mx-auto w-full max-w-[1220px]">
          <div className="w-full rounded-lg border border-white/15 bg-white/10 p-2 backdrop-blur-sm">
            <div className="flex flex-wrap items-stretch gap-2">
              <span className="zone-label flex items-center gap-1.5 px-3 py-2 text-[11px] text-white/70">
                <i className="ri-links-line"></i>
                快速入口
              </span>
              {entryLinks.map((entry) => (
                <a
                  key={entry.label}
                  href="#archive"
                  className="group min-w-[128px] flex-1 rounded-md bg-white/5 px-3 py-2 transition-colors hover:bg-white/15"
                >
                  <span className="block text-sm font-medium text-white">{entry.label}</span>
                  <span className="mt-0.5 block text-[11px] text-white/60">{entry.desc}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="mt-8 grid grid-cols-1 items-end gap-6 lg:grid-cols-[1fr_360px]">
            <div>
              <div className="flex flex-wrap items-center gap-2 text-[11px] text-white/70">
                <span className="zone-label rounded-full bg-primary-600 px-2.5 py-1 text-white">来源溯源</span>
                <span className="zone-label">事件归档 · 首发追踪 · 出处梳理</span>
              </div>
              <h2 className="mt-4 font-heading text-3xl font-bold leading-snug text-white md:text-5xl">
                每张黑料照片，都该说清它从哪来
              </h2>
              <p className="mt-4 max-w-2xl text-sm leading-relaxed text-white/70 md:text-base">
                深挖每张照片的原始来源与首发路径，梳理最早出现在哪个平台、由谁爆出、拍摄背景与泄露链条。按事件归档，点开就能看到完整出处梳理，适合想追根溯源的吃瓜网友。
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <a
                  href="#archive"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600"
                >
                  <i className="ri-archive-line"></i>
                  进入事件归档
                </a>
                <a
                  href="#trace"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-white/25 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-white/10"
                >
                  <i className="ri-route-line"></i>
                  查看首发路径
                </a>
              </div>
            </div>

            <div className="w-full rounded-lg border border-white/15 bg-black/35 p-4 backdrop-blur-sm">
              <div className="flex items-center justify-between">
                <span className="zone-label text-[11px] text-white/60">今日速览</span>
                <span className="flex items-center gap-1 text-[11px] text-accent-300">
                  <i className="ri-flashlight-line"></i>
                  实时更新
                </span>
              </div>
              <div className="mt-3 grid grid-cols-2 gap-3">
                {statCards.map((stat) => (
                  <div key={stat.label} className="rounded-md bg-white/5 px-3 py-2.5">
                    <div className="font-heading text-xl font-bold text-white md:text-2xl">{stat.value}</div>
                    <div className="mt-0.5 text-[11px] text-white/60">{stat.label}</div>
                    <div className="mt-0.5 text-[10px] text-white/40">{stat.sub}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}